/**
 * Built-in document templates. Content is generated on demand so date-based
 * templates (daily note, meeting) stamp the current date. The display name is an
 * i18n key; the body is intentionally plain Markdown (English structure) that
 * the user then fills in.
 */
import { formatDate } from './format';

export interface Template {
  id: string;
  /** i18n key for the picker label. */
  nameKey: string;
  content: () => string;
}

const today = (): string => formatDate(Date.now());

export const TEMPLATES: Template[] = [
  { id: 'blank', nameKey: 'tpl.blank', content: () => '' },
  {
    id: 'daily',
    nameKey: 'tpl.daily',
    content: () => `# ${today()}\n\n## Focus\n\n- \n\n## Notes\n\n## Log\n\n`,
  },
  {
    id: 'meeting',
    nameKey: 'tpl.meeting',
    content: () =>
      `# Meeting — ${today()}\n\n**Attendees:** \n\n## Agenda\n\n- \n\n## Notes\n\n## Action items\n\n- [ ] \n`,
  },
  {
    id: 'blog',
    nameKey: 'tpl.blog',
    content: () =>
      `# Title\n\n_Draft — ${today()}_\n\nIntroduction.\n\n## Section\n\n\n\n## Conclusion\n\n`,
  },
  {
    id: 'todo',
    nameKey: 'tpl.todo',
    content: () => `# To-do\n\n- [ ] \n- [ ] \n- [ ] \n`,
  },
  {
    id: 'readme',
    nameKey: 'tpl.readme',
    content: () =>
      `# Project\n\n> One-line description.\n\n## Features\n\n- \n\n## Getting started\n\n\`\`\`bash\n\n\`\`\`\n\n## License\n\nMIT\n`,
  },
];
